(function () {
  function isMobile() {
    return window.matchMedia('(max-width: 767.98px)').matches;
  }

  function getVisibleImage(media) {
    var desktop = media.querySelector('.simple-image__img--desktop');
    var mobile = media.querySelector('.simple-image__img--mobile');
    if (isMobile()) return mobile || desktop;
    return desktop || mobile;
  }

  function setAspectRatio(media, width, height) {
    var w = Number(width);
    var h = Number(height);
    if (!media || !w || !h) return;
    media.style.setProperty('--simple-image-aspect-ratio', w + ' / ' + h);
  }

  function applyAspectRatio(media) {
    var img = getVisibleImage(media);
    if (!img) return;

    function applyFromImage() {
      if (img.naturalWidth && img.naturalHeight) {
        setAspectRatio(media, img.naturalWidth, img.naturalHeight);
      }
    }

    if (img.complete) {
      applyFromImage();
    } else {
      img.addEventListener('load', applyFromImage, { once: true });
    }
  }

  function initSection(section) {
    if (!section) return;
    section.querySelectorAll('[data-simple-image-media]').forEach(applyAspectRatio);
  }

  function initAll(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-simple-image]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  window.addEventListener('resize', function () {
    initAll();
  });
})();
